import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  addResourceGroup(request: Boundaries["addResourceGroup"]["request"]): void;
}

function useAddResourceGroup(namespace: string): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isAddResourceGroupRequestPending(namespace),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isAddResourceGroupRequestSuccess(namespace),
    ),
    isRequestFailure: useSelector(() =>
      selector.isAddResourceGroupRequestFailure(namespace),
    ),
    addResourceGroup: core.addResourceGroup,
  };
}

export { useAddResourceGroup };
